<template>
    <EChart
        :options="chartData"
        :group-by="currentGroupBy"
        card
        type="time"
        :header="$t('averagePriceInTime')"
        :tooltip="$t('tooltipNewReportIsCreated')"
        :loading="request.getLoading()"
    >
        <template #nav>
            <div :key="spaceId" class="d-flex gap-3 flex-column">
                <DropdownFilter v-model="currentGroupBy" :items="['day', 'month', 'quarter', 'year']" :prefix="`${$t('range')}: `" :disabled="request.getLoading()" />
            </div>
        </template>
    </EChart>
</template>



<script>
    import { startOfDay, startOfMonth, startOfQuarter, startOfYear } from 'date-fns';
    import EChart from '@/components/common/EChart.vue';
    import DropdownFilter from '@/components/common/DropdownFilter.vue';

    export default {
        name: 'AveragePriceInTime',
        components: {
            EChart,
            DropdownFilter,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                request: this.parentComponent.requestData1,
                currentGroupBy: 'day',
            };
        },
        computed: {
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            data() {
                return this.parentComponent.data;
            },
            chartData() {
                if (!this.data?.length) return { series: [] };

                // Pomocnicza funkcja wyznaczająca początek grupy wg groupBy (lokalny czas)
                const getBucketStartTimestamp = (timestampMs, groupBy) => {
                    const originalDate = new Date(Number(timestampMs));

                    switch (groupBy) {
                        case 'day':
                            return startOfDay(originalDate).getTime();
                        case 'month':
                            return startOfMonth(originalDate).getTime();
                        case 'quarter':
                            return startOfQuarter(originalDate).getTime();
                        case 'year':
                            return startOfYear(originalDate).getTime();
                        default:
                            return startOfDay(originalDate).getTime();
                    }
                };

                const storeDataMap = {};

                this.data.forEach(productItem => {
                    const reportObject = productItem?.report;
                    if (!reportObject) return;

                    Object.entries(reportObject).forEach(([storeName, storeReport]) => {
                        if (!storeReport?.chart?.length) return;

                        storeReport.chart.forEach(({ date, avg }) => {
                            if (avg === null || avg === undefined) return;

                            const originalTs = Number(date);
                            const bucketStartTs = getBucketStartTimestamp(originalTs, this.currentGroupBy);

                            if (!storeDataMap[storeName]) storeDataMap[storeName] = {};
                            if (!storeDataMap[storeName][bucketStartTs]) storeDataMap[storeName][bucketStartTs] = [];
                            storeDataMap[storeName][bucketStartTs].push(avg);
                        });
                    });
                });

                // Dla każdego sklepu tworzymy punkty [bucketStart, średnia]
                const series = Object.entries(storeDataMap).map(([storeName, bucketsMap]) => {
                    const dataPoints = Object.entries(bucketsMap).map(([bucketStart, values]) => {
                        const average = values.reduce((sum, value) => sum + value, 0) / values.length;
                        return [Number(bucketStart), average];
                    });
                    dataPoints.sort((a, b) => a[0] - b[0]);

                    return {
                        name: storeName,
                        type: 'line',
                        areaStyle: null,
                        data: dataPoints,
                    };
                });

                return {
                    tooltip: {
                        trigger: 'axis',
                        valueFormatter: value => this.$format.currency(value),
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: val => this.$format.currency(val, null, null, 0),
                        },
                    },
                    series,
                };
            },
        },
        watch: {
            spaceId() {
                this.resetFilters();
            },
        },
        methods: {
            resetFilters() {
                this.currentGroupBy = 'day';
            },
        },
        created() {
            this.parentComponent.$on('resetFilters', this.resetFilters);
        },
        beforeDestroy() {
            this.parentComponent.$off('resetFilters', this.resetFilters);
        },
    };
</script>
